"use client";
import { jsxs, Fragment, jsx } from "react/jsx-runtime";
import { useSearchParams } from "next/navigation";
import { useAgent } from "../../../../../../utils/agent/AgentProvider.js";
import { useState } from "react";
import { QuantitySelector } from "@nxt-costco-com/forge-components";
import ExtraCartMessage from "../../../../ExtraCartMessage/index.js";
import { useWcsToken } from "../../../../../../hooks/auth/useWcsToken/index.js";
import { checkAddToCartError, getActionType } from "./utils.js";
import { buttonStyles } from "./styles.js";
const AddToCartButton = ({
  maxQuantity,
  contractIdentifier,
  itemNumber,
  minQuantity,
  partNumber,
  urls,
  addbuttonlabel,
  decreasequantity,
  addtocartsuccessmessage,
  increasequantity,
  quantity,
  removeitemarialabel,
  removeitemerror,
  genericerror,
  productTitleId,
  refreshCartCallback
}) => {
  const [addToCartState, setAddToCartState] = useState();
  const { agent } = useAgent();
  useSearchParams();
  const { getTokenValue } = useWcsToken();
  const {
    response,
    qty = 0,
    isLoading,
    action,
    orderItem_id,
    orderId
  } = addToCartState || {};
  const customErrorMsg = checkAddToCartError(
    response
  );
  const onQuantityChange = async (updatedQuantity, type) => {
    if (type === "change" || qty === updatedQuantity) {
      return;
    }
    const actionType = getActionType(updatedQuantity, type, orderId);
    if (type === "add" && !updatedQuantity) {
      updatedQuantity = 1;
    }
    const paramsObj = {
      "In-Cart": "in cart",
      actionType,
      ajaxFlag: true,
      checkOmsInventory: true,
      contractIdentifier,
      isQuickAddToCartButton: true,
      isRestrictedPostalCode: !!(localStorage == null ? void 0 : localStorage.getItem(
        "isRestrictedPostalCode"
      )),
      itemNumber,
      maxQuantity,
      minQuantity,
      partNumber,
      quantity: updatedQuantity,
      quantity_1: updatedQuantity
    };
    try {
      const authToken = await getTokenValue(true);
      setAddToCartState((prev) => {
        return {
          ...prev,
          action: "",
          isLoading: true
        };
      });
      const res = await (agent == null ? void 0 : agent.postAddToCartDetails(urls == null ? void 0 : urls.addToCartURL, {
        ...paramsObj,
        ...orderId && { orderId },
        ...type !== "add" && {
          orderItem_1: (response == null ? void 0 : response.orderItemId) || orderItem_id
        },
        authToken
      }));
      setAddToCartState((prev) => {
        return {
          ...prev,
          action: type,
          isLoading: false,
          orderId: !(prev == null ? void 0 : prev.orderId) ? res == null ? void 0 : res.orderId : prev.orderId,
          orderItem_id: !(prev == null ? void 0 : prev.orderItem_id) ? res == null ? void 0 : res.orderItemId : prev.orderItem_id,
          qty: res == null ? void 0 : res.itemMessage,
          response: updatedQuantity === 0 && checkAddToCartError(res) ? {
            ...res,
            customErrorLabel: removeitemerror
          } : res
        };
      });
      refreshCartCallback();
    } catch (error) {
      console.error("Add to cart post request failed:", error);
      setAddToCartState((prev) => {
        return {
          ...prev,
          action: "",
          isLoading: false,
          response: {
            customErrorLabel: genericerror
          }
        };
      });
    }
  };
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(
      QuantitySelector,
      {
        maxValue: !isNaN(Number(maxQuantity)) ? Number(maxQuantity) : void 0,
        minValue: !isNaN(Number(minQuantity)) ? Number(minQuantity) : void 0,
        action,
        addToCartLabel: addbuttonlabel,
        customErrorMsg,
        decrementAriaLabel: decreasequantity,
        inCartLabel: addtocartsuccessmessage,
        incrementAriaLabel: increasequantity,
        inputAriaLabel: quantity,
        isAddToCartVariant: true,
        isAddToCartVisible: +qty === 0,
        isLoading,
        onQuantityChange,
        parentUniqueId: productTitleId,
        quantityLabel: quantity,
        removeCartAriaLabel: removeitemarialabel,
        sx: buttonStyles,
        uniqueId: `PRODUCT_ACTIONS_${partNumber}`,
        updateQuantity: qty,
        isDeleteFromCartMessage: !((response == null ? void 0 : response.itemMessage) === 0 && action === "decrement")
      }
    ),
    /* @__PURE__ */ jsx(ExtraCartMessage, { errorState: customErrorMsg, quantity: qty })
  ] });
};
export {
  AddToCartButton
};
